<template>
    <div class="ba-w-100 ba-grid ba-gp-08">
        <div class="ba-w-100 ba-flex ba-gp-08 ba-ai-center ba-jc-fe" style="height: 45px;">
            <div v-if="items.length > 0" class='ba-box-search-input ba-h-100'>
                <input  type="search" class="ba-input ba-md" :placeholder="$t('ct-search')"
                    v-model="filtro" />
                <button class='ba-button'>
                    <builderall-icon code='search' />
                </button>
            </div>
            <button type="button" class="ba-btn ba-md ba-blue ba-h-100" @click="$refs.addItem.open()" >
                <builderall-icon code='2780'></builderall-icon>
                {{ $t(`ct-new-multiple-actions`) }}
            </button>
        </div>
        <div v-if="!items.length == false" class="ba-grid ba-gp-08">
            <div class="ba-w-100 ba-grid ba-gp-08">
                <div class="ba-card ba-no-shadow ba-w-100" style="background-color: #eff2f8;">
                    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-sb">
                        <span class="ba-montserrat-600">{{ $t('ct-name') }}</span>
                    </div>
                </div>
                <div class="ba-card ba-w-100 ba-blue ba-no-shadow" v-for="(item, index) of filterItems" :key="index"
                    style="height: 60px;">
                    <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100">
                        <span class="ba-montserrat-700 ba-text-14" style="width: 450px;"> {{ item.name }} </span>
                        <hr class="ba-hr-column" style="height: 30px;">
                        <div class="ba-flex ba-ai-center ba-gp-08">
                            <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click="$emit('multiActionEdit', item)" ba-tooltip-position='top'
                                :ba-tooltip-title="$t('ct-edit')">
                                <builderall-icon code='edit' />
                            </button>
                            <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="duplicate(item)"
                                ba-tooltip-position='top' :ba-tooltip-title="$t('ct-duplicate')">
                                <builderall-icon code='b54c'></builderall-icon>
                            </button>
                            <button class='ba-btn ba-btn-trash ba-sm ba-rounded'
                                @click.prevent="openConfirmDelete(item)" ba-tooltip-position='top'
                                :ba-tooltip-title="$t('ct-remove')">
                                <builderall-icon code='trash' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ba-w-100" v-if="viewMore">
                <button type="button" @click="loadMore" class="ba-btn ba-blue ba-md ba-w-100">
                    {{ $t(`ct-load-more`) }}
                </button>

            </div>
        </div>
        <!--    ADD -->
        <sweet-modal ref="addItem" width="60vw" hide-close-button>
            <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
                <h5 class="ba-color-blue1">{{ $t('ct-new-multiple-actions') }}</h5>
                <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="$refs.addItem.close()">
                    <builderall-icon code='64f7' />
                </button>
            </div>
            <hr class='ba-hr-row'>
            <div class="ba-grid ba-mg-y-1 ba-gp-08">
                <span class="ba-custom-label">{{ $t('ct-name') }}</span>
                <input v-model="item.name" class="ba-input ba-w-100" maxlength="200"
                    :placeholder="$t(`ct-create-multiple-actions`)" rows="3" required />
            </div>
            <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
                <button slot="button" class="ba-btn ba-md ba-light" @click="cancelNew">{{
                    $t('ct-cancel') }}</button>
                <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="create()" :disabled="!item.name">{{ $t('ct-save')
                    }}</button>
            </div>
        </sweet-modal>
        <!--    DELETE -->
        <modal-delete
            :show="modalDelete.show"
            :values="remover"
            @cancel="cancelConfirmDelete"
            @exclude="exclude"
        ></modal-delete>
        <!-- <sweet-modal ref="removeItem" :title="this.$t('title-remove-confirm')" width="30%" blocking>
            <div class="border bg-light p-5 text-center mt-4">
                <p>
                    <strong> {{ remover.description }}</strong>
                </p>
            </div>
            <button slot="button" class="btn btn-outline-light" @click="cancelConfirmDelete()">
                {{ $t("ct-cancel") }}
            </button>
            <button slot="button" class="btn btn-danger" @click="exclude()">
                <i class="svg-icon svgi-link"></i>{{ $t("ct-remove") }}
            </button>
        </sweet-modal> -->
    </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import ModalDelete from "../components/ModalDelete.vue";
// import { get, create as createQuestion, destroy as deleteQuestion } from "../../../js/services/editor/votesystem";
import {
  get as getMultiaction,
  create as createMultiaction,
//   update as updateMultiaction,
  destroy as deleteMultiaction,
} from "../../../js/services/editor/multiactions";
export default {
    name: "MultiActionsList",
    components: { SweetModal, ModalDelete },
    data() {
        return {
            items: [],
            website_id: null,
            layout_id: null,
            item: {
                name: "",
                layout_id: null,
            },
            filtro: "",
            viewMore: false,
            remover: {},
            modalDelete: {
                show: false,
                values: ''
            }
        };
    },
    watch: {
        type: async function () {
            this.filtro = "";
            await this.updateMultiaction();
        },

        items: function () {
            this.viewMore = this.items.length > 15 ? true : false;
        },
    },
    methods: {
        updateMultiaction() {
            this.$emit('loading', true);
            getMultiaction(this.$route.params.id)
                .then((response) => {
                    this.items = response.data.data;
                    this.$emit('loading', false)
                })
                .finally(() => this.$emit('loading', false));

        },
        cancelNew() {
            this.item.description = "";
            this.$refs.addItem.close();
        },
        create(copy = false) {
            if (copy) {
                this.item = copy;
                this.item.name += " - copy";
            }
            this.item.website_id = this.$route.params.id;
            if (this.validate()) {
                this.$emit('loading', true);
                createMultiaction(this.item)
                    .then((res) => {
                        this.$snotify.success(this.$t("ct-saved-successfully"));
                        this.item.name = ""
                        this.updateMultiaction();
                        this.$refs.addItem.close();
                        this.$emit('loading', false);
                    })
                    .finally(() => this.$emit('loading', false));
            } else {
                this.$snotify.error(this.$t(`ct-item-name-required`));
            }
        },

        validate() {
            if (!this.item.name && !(this.item.name.length > 0)) {
                return false;
            }
            return true;
        },

        openConfirmDelete(remover) {
            this.remover = remover;
            this.modalDelete.values = remover.name;
            this.modalDelete.show = true;
        },

        cancelConfirmDelete() {
            this.remover = {};
            this.modalDelete.show = false;
        },

        exclude() {
            this.$emit('loading', true);
            deleteMultiaction(this.remover)
                .then((res) => {
                    this.modalDelete.show = false;
                    this.updateMultiaction();
                    this.$emit('loading', false);
                })
                .finally(() => this.$emit('loading', false));
        },

        duplicate(item) {
            item.website_id = this.$route.params.id;
            this.create(item);
        },

        loadMore() { },
    },
    async created() {
        await this.updateMultiaction();
    },
    computed: {
        filterItems() {
            return this.items.filter((item) => {
                return item.name.match(this.filtro);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
header form {
    position: relative;
    height: 47px;
    margin-right: 20px;

    i {
        position: absolute;
        left: 20px;
        top: 15px;
    }

    input {
        height: -webkit-fill-available;
        padding-left: 45px;
    }
}

section {
    .card-tags-group {
        font-family: Lato;
        text-transform: uppercase;

        .card-header,
        textarea {
            font-size: 18px;
            color: #0080fc;
            font-weight: 700;
            text-align: center;
        }

        form textarea {
            border: none;
            background: transparent;
            padding: 0;
            resize: none;

            &::placeholder {
                /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: #0080fc;
                opacity: 1;
                /* Firefox */
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: #0080fc;
            }

            &::-ms-input-placeholder {
                /* Microsoft Edge */
                color: #0080fc;
            }
        }

        .card-body {
            display: flex;
            flex-direction: row;
            justify-content: center;
        }
    }

    .sombra {
        box-shadow: 0 0 0 100vw #59607175;
        z-index: 2;
    }

    .btn-grey {
        background: #fcfcfc;
        padding: 25px 0 !important;
        font-weight: 600 !important;
    }
}

.btn .svgi-trash {
    filter: brightness(5);
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/MultiActionsList.vue